export const iconFontAwesomeTextformattingCheck = (
	<i className="fa-solid fa-check"></i>
);
